<template>
  <div>
    <button
      @click="openModal"
      class="btn-condividi"
      :disabled="featureLocked"
      :title="shareButtonTitle"
    >
      <i class="fa-solid fa-share-nodes"></i> Condividi
      <span v-if="invitiInAttesaCount > 0" class="badge">{{
        invitiInAttesaCount
      }}</span>
    </button>

    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div
        class="modal-content condividi-modal"
        role="dialog"
        aria-modal="true"
      >
        <header class="share-modal-header">
          <span class="share-modal-icon" aria-hidden="true">
            <i class="fa-solid fa-share-nodes"></i>
          </span>
          <span class="share-modal-title">
            <strong>Condividi la tua Libreria</strong>
            <small>
              Seleziona i documenti, scegli i colleghi e gestisci gli inviti.
            </small>
          </span>
          <button
            type="button"
            class="share-modal-close"
            aria-label="Chiudi"
            @click="closeModal"
          >
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          </button>
        </header>

        <div v-if="actionError" class="share-feedback error">
          {{ actionError }}
        </div>

        <div class="modal-body">
          <section class="modal-section invia">
            <div class="modal-section-heading">
              <span class="section-heading-icon section-heading-icon--share">
                <i class="fa-solid fa-paper-plane" aria-hidden="true"></i>
              </span>
              <span>
                <strong>Condividi</strong>
                <small>Prepara una nuova condivisione.</small>
              </span>
            </div>

            <div class="share-compose-scroll">
              <div class="selection-card selection-card--files">
                <div class="selection-card-heading">
                  <span class="selection-card-icon selection-card-icon--files">
                    <i class="fa-solid fa-file-lines" aria-hidden="true"></i>
                  </span>
                  <span class="selection-card-title">
                    <strong>Documenti</strong>
                    <small>Seleziona uno o più file della libreria.</small>
                  </span>
                  <span class="selection-count">
                    {{ selectedFileKeysForSubmit.length }} selezionati
                  </span>
                </div>
                <div
                  v-if="groupedShareableFiles.length"
                  class="share-file-list"
                >
                  <div
                    v-for="section in groupedShareableFiles"
                    :key="section.key"
                    class="share-file-section"
                  >
                    <span class="share-file-section-title">
                      {{ section.label }}
                    </span>
                    <div
                      v-if="section.key === 'personalizzati'"
                      class="share-client-list"
                    >
                      <div
                        v-for="client in section.clients"
                        :key="client.key"
                        class="share-client-group"
                      >
                        <div class="share-client-heading">
                          <i class="fa-solid fa-star" aria-hidden="true"></i>
                          <span>{{ client.label }}</span>
                        </div>
                        <div class="share-client-actions">
                          <label
                            v-for="file in client.files"
                            :key="file.key"
                            class="share-file-chip"
                            :class="{
                              selected: selectedFileKeys.includes(file.key),
                            }"
                          >
                            <input
                              v-model="selectedFileKeys"
                              type="checkbox"
                              :value="file.key"
                              :disabled="isSending"
                            />
                            <span
                              class="share-file-type-icon"
                              aria-hidden="true"
                            >
                              <i :class="file.icon"></i>
                            </span>
                            <span>{{ file.shortLabel || file.label }}</span>
                            <small
                              v-if="file.status && file.status.label"
                              class="share-file-status"
                              :class="`share-file-status--${file.status.kind}`"
                            >
                              {{ file.status.label }}
                            </small>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div v-else class="share-main-list">
                      <label
                        v-for="file in section.files"
                        :key="file.key"
                        class="share-file-row"
                        :class="{
                          selected: selectedFileKeys.includes(file.key),
                        }"
                      >
                        <input
                          v-model="selectedFileKeys"
                          type="checkbox"
                          :value="file.key"
                          :disabled="isSending"
                        />
                        <span class="share-file-type-icon" aria-hidden="true">
                          <i :class="file.icon"></i>
                        </span>
                        <span class="share-file-row-text">
                          <strong>{{ file.label }}</strong>
                          <small>{{ file.meta }}</small>
                        </span>
                        <small
                          v-if="file.status && file.status.label"
                          class="share-file-status"
                          :class="`share-file-status--${file.status.kind}`"
                        >
                          {{ file.status.label }}
                        </small>
                      </label>
                    </div>
                  </div>
                </div>
                <p v-else class="empty-state">
                  Nessun file disponibile per la condivisione.
                </p>
              </div>

              <div class="selection-card selection-card--users">
                <div class="selection-card-heading">
                  <span class="selection-card-icon selection-card-icon--users">
                    <i class="fa-solid fa-users" aria-hidden="true"></i>
                  </span>
                  <span class="selection-card-title">
                    <strong>Destinatari</strong>
                    <small>Seleziona i colleghi dello studio.</small>
                  </span>
                  <span class="selection-count">
                    {{ selectedUserEmails.length }} selezionati
                  </span>
                </div>
                <div v-if="utentiStudio.length" class="selection-toolbar">
                  <button
                    type="button"
                    class="toolbar-link"
                    @click="selezionaTuttiUtenti"
                    :disabled="isSending"
                  >
                    Seleziona tutti
                  </button>
                  <button
                    type="button"
                    class="toolbar-link"
                    @click="deselezionaTuttiUtenti"
                    :disabled="selectedUserEmails.length === 0 || isSending"
                  >
                    Deseleziona
                  </button>
                </div>
                <div v-if="utentiStudio.length" class="checkbox-list">
                  <label
                    v-for="utente in sortedUtentiStudio"
                    :key="utente.id || utente.email"
                    class="checkbox-row"
                  >
                    <input
                      v-model="selectedUserEmails"
                      type="checkbox"
                      :value="utente.email"
                      :disabled="isSending"
                    />
                    <span
                      class="recipient-avatar"
                      :style="recipientAvatarStyle(utente)"
                      aria-hidden="true"
                    >
                      {{ recipientInitials(utente) }}
                    </span>
                    <span class="user-option-text">
                      <strong class="user-option-name">
                        {{ formatUserDisplayName(utente) }}
                      </strong>
                      <small
                        v-if="shouldShowUserEmail(utente)"
                        class="user-option-email"
                      >
                        {{ utente.email }}
                      </small>
                    </span>
                  </label>
                </div>
                <p v-else class="empty-state">
                  Nessun collega disponibile per la condivisione.
                </p>
              </div>
            </div>
          </section>

          <section class="modal-section inviti-unici">
            <div class="modal-section-heading">
              <span class="section-heading-icon section-heading-icon--invites">
                <i
                  class="fa-solid fa-envelope-open-text"
                  aria-hidden="true"
                ></i>
              </span>
              <span>
                <strong>I tuoi inviti</strong>
                <small>Controlla lo stato e gestisci i file condivisi.</small>
              </span>
              <span v-if="invitiCombinati.length" class="invite-total">
                {{ invitiCombinati.length }}
              </span>
            </div>

            <div v-if="showCancelAllConfirm" class="bulk-cancel-confirm">
              <span>
                Annullare {{ invitiInviatiInAttesa.length }} inviti inviati in
                attesa?
              </span>
              <div class="bulk-cancel-actions">
                <button
                  type="button"
                  class="bulk-cancel-action bulk-cancel-action--confirm"
                  @click="annullaTuttiInvitiInviati"
                  :disabled="isCancellingAllInvites"
                >
                  Conferma
                </button>
                <button
                  type="button"
                  class="bulk-cancel-action"
                  @click="showCancelAllConfirm = false"
                  :disabled="isCancellingAllInvites"
                >
                  Annulla
                </button>
              </div>
            </div>

            <div v-if="invitiCombinati.length" class="invite-scroll">
              <section
                v-for="group in inviteGroups"
                :key="group.key"
                class="invite-group"
                :class="`invite-group--${group.key}`"
              >
                <header class="invite-group-heading">
                  <span class="invite-group-icon">
                    <i :class="group.icon" aria-hidden="true"></i>
                  </span>
                  <span class="invite-group-title">
                    <strong>{{ group.label }}</strong>
                    <small>{{ group.helper }}</small>
                  </span>
                  <span class="invite-group-count">{{
                    group.invites.length
                  }}</span>
                  <button
                    v-if="
                      group.key === 'sent' &&
                      canCancelAllSentInvites &&
                      !showCancelAllConfirm
                    "
                    type="button"
                    class="btn-annulla-tutti"
                    @click="requestCancelAllSentInvites"
                    :disabled="isCancellingAllInvites"
                  >
                    {{
                      isCancellingAllInvites
                        ? "Annullamento..."
                        : "Annulla tutti"
                    }}
                  </button>
                </header>

                <ul v-if="group.invites.length" class="lista-inviti">
                  <li
                    v-for="invito in group.invites"
                    :key="invito.id"
                    class="invito-item"
                    :class="{ highlighted: isHighlightedInvito(invito) }"
                  >
                    <span
                      class="invite-avatar"
                      :style="
                        avatarStyleForText(
                          invito.tipo === 'ricevuto' ? invito.da : invito.a
                        )
                      "
                      aria-hidden="true"
                    >
                      {{
                        avatarInitialsFromText(
                          invito.tipo === "ricevuto" ? invito.da : invito.a
                        )
                      }}
                    </span>
                    <div class="info-invito">
                      <template v-if="invito.tipo === 'ricevuto'">
                        <span class="invito-user"
                          ><strong>Da:</strong> {{ invito.da }}</span
                        >
                      </template>
                      <template v-else>
                        <span class="invito-user"
                          ><strong>A:</strong> {{ invito.a }}</span
                        >
                      </template>

                      <div class="invito-meta">
                        <span
                          class="invite-status"
                          :class="inviteStatusClass(invito.stato)"
                        >
                          {{ invito.stato }}
                        </span>
                        <small>
                          <strong>Data:</strong> {{ formattaData(invito.data) }}
                        </small>
                      </div>

                      <div class="shared-files">
                        <span
                          v-for="file in invito.shared_files"
                          :key="file.key"
                          class="file-pill"
                        >
                          {{ file.label }}
                        </span>
                      </div>
                    </div>

                    <div class="invito-controls">
                      <div class="preview-actions">
                        <button
                          v-for="file in invito.shared_files"
                          :key="`${invito.id}-${file.key}`"
                          @click="visualizzaExcel(invito.id, file)"
                          class="btn-preview"
                          :title="`Visualizza ${file.label}`"
                        >
                          <i class="fa-solid fa-eye"></i>
                          {{ shortFileLabel(file.label) }}
                        </button>
                      </div>

                      <div
                        v-if="
                          invito.tipo === 'ricevuto' &&
                          invito.stato === 'in attesa'
                        "
                        class="actions"
                      >
                        <button
                          @click="rispondi(invito.id, 'accettato')"
                          :disabled="isResponding(invito.id)"
                          class="btn-accetta"
                          title="Sostituisci i tuoi file con quelli ricevuti"
                        >
                          {{
                            isResponding(invito.id) ? "Attendi..." : "Accetta"
                          }}
                        </button>
                        <button
                          @click="rispondi(invito.id, 'rifiutato')"
                          :disabled="isResponding(invito.id)"
                          class="btn-rifiuta"
                        >
                          Rifiuta
                        </button>
                      </div>

                      <div
                        v-else-if="
                          invito.tipo === 'inviato' &&
                          invito.stato === 'in attesa'
                        "
                        class="actions"
                      >
                        <button
                          @click="annullaInvito(invito.id)"
                          :disabled="
                            loadingAnnullamenti[invito.id] ||
                            isCancellingAllInvites
                          "
                          class="btn-annulla"
                        >
                          {{
                            loadingAnnullamenti[invito.id]
                              ? "Annullamento..."
                              : "Annulla Invito"
                          }}
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
                <p v-else class="invite-empty">{{ group.emptyLabel }}</p>
              </section>
            </div>
            <p v-else class="no-inviti">Nessun invito presente.</p>
          </section>
        </div>

        <div class="modal-footer">
          <div class="selection-summary">
            <span>
              <i class="fa-solid fa-file-lines" aria-hidden="true"></i>
              <strong>{{ selectedFileKeysForSubmit.length }}</strong>
              documenti
            </span>
            <span>
              <i class="fa-solid fa-users" aria-hidden="true"></i>
              <strong>{{ selectedUserEmails.length }}</strong>
              destinatari
            </span>
          </div>
          <div class="modal-footer-actions">
            <button @click="inviaPiano" :disabled="!canSend" class="btn-invia">
              <i class="fa-solid fa-paper-plane" aria-hidden="true"></i>
              {{ isSending ? "Invio in corso..." : "Invia" }}
            </button>
            <button @click="closeModal" class="btn-chiudi">Chiudi</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/config";
import { isGuestMode } from "@/utils/guestMode";
import * as XLSX from "xlsx";

export default {
  name: "CondivisionePiano",
  inheritAttrs: false,
  props: {
    tipoPiano: String,
    onRefreshFiles: Function,
    invitiRicevuti: { type: Array, default: () => [] },
    invitiInviati: { type: Array, default: () => [] },
    shareableFiles: { type: Array, default: () => [] },
    autoOpen: { type: Boolean, default: false },
    highlightedInvitoId: { type: [Number, String], default: null },
    jsonLength: {
      type: Number,
      required: true,
    },
    featureLocked: { type: Boolean, default: false },
    featureTitle: { type: String, default: "" },
  },
  data() {
    return {
      utentiStudio: [],
      selectedUserEmails: [],
      selectedFileKeys: [],
      showModal: false,
      isSending: false,
      loadingAnnullamenti: {},
      loadingRisposte: {},
      isCancellingAllInvites: false,
      showCancelAllConfirm: false,
      actionError: "",
    };
  },
  computed: {
    isGuestMode() {
      return isGuestMode();
    },
    shareButtonTitle() {
      return this.featureTitle || this.$attrs.title || null;
    },
    sortedUtentiStudio() {
      return [...this.utentiStudio].sort((left, right) =>
        this.getUserSortKey(left).localeCompare(
          this.getUserSortKey(right),
          "it",
          {
            sensitivity: "base",
          }
        )
      );
    },
    normalizedShareableFiles() {
      if (Array.isArray(this.shareableFiles)) {
        return this.shareableFiles.map((file) => {
          const isClientFile =
            file.section === "personalizzati" || Boolean(file.clientKey);
          return {
            key: file.key,
            label: file.label,
            shortLabel: file.shortLabel || file.label,
            meta: file.meta || (isClientFile ? "Personalizzato" : "Principale"),
            icon: file.icon || "fa-solid fa-file-excel",
            status: file.status || null,
            section: isClientFile ? "personalizzati" : "principali",
            sectionLabel: isClientFile ? "Personalizzati" : "Principale",
            clientKey: file.clientKey || null,
            clientLabel: file.clientLabel || file.clientKey || "",
          };
        });
      }

      return [
        {
          key: "main",
          label: this.tipoPiano,
          shortLabel: this.tipoPiano,
          meta: "Principale",
          icon: "fa-solid fa-file-excel",
          status: null,
          section: "principali",
          sectionLabel: "Principale",
          clientKey: null,
          clientLabel: "",
        },
      ];
    },
    groupedShareableFiles() {
      const principali = this.normalizedShareableFiles.filter(
        (file) => file.section !== "personalizzati"
      );
      const personalizzati = this.normalizedShareableFiles.filter(
        (file) => file.section === "personalizzati"
      );
      const sections = [];

      if (principali.length) {
        sections.push({
          key: "principali",
          label: "Principale",
          files: principali,
        });
      }

      if (personalizzati.length) {
        const clientsByKey = new Map();
        personalizzati.forEach((file) => {
          const clientKey = file.clientKey || file.clientLabel || "cliente";
          if (!clientsByKey.has(clientKey)) {
            clientsByKey.set(clientKey, {
              key: clientKey,
              label: file.clientLabel || clientKey,
              files: [],
            });
          }
          clientsByKey.get(clientKey).files.push(file);
        });
        sections.push({
          key: "personalizzati",
          label: "Personalizzati",
          clients: [...clientsByKey.values()].sort((left, right) =>
            left.label.localeCompare(right.label, "it")
          ),
        });
      }

      return sections;
    },
    selectedFileKeysForSubmit() {
      const availableKeys = new Set(
        this.normalizedShareableFiles.map((file) => file.key)
      );
      return [...new Set(this.selectedFileKeys)].filter((key) =>
        availableKeys.has(key)
      );
    },
    canSend() {
      return (
        this.selectedUserEmails.length > 0 &&
        this.selectedFileKeysForSubmit.length > 0 &&
        !this.isSending
      );
    },
    invitiCombinati() {
      const ricevuti = this.invitiRicevuti
        .filter((i) => i.tipo_piano === this.tipoPiano)
        .map((i) => ({
          ...i,
          tipo: "ricevuto",
          shared_files: this.normalizeInviteSharedFiles(i),
        }));

      const inviati = this.invitiInviati
        .filter((i) => i.tipo_piano === this.tipoPiano)
        .map((i) => ({
          ...i,
          tipo: "inviato",
          shared_files: this.normalizeInviteSharedFiles(i),
        }));

      return [...ricevuti, ...inviati].sort((a, b) => {
        const aDate = a.data ? new Date(a.data).getTime() : 0;
        const bDate = b.data ? new Date(b.data).getTime() : 0;
        return bDate - aDate;
      });
    },
    inviteGroups() {
      const sent = this.invitiCombinati.filter(
        (invito) => invito.tipo === "inviato"
      );
      const received = this.invitiCombinati.filter(
        (invito) => invito.tipo === "ricevuto"
      );

      return [
        {
          key: "sent",
          label: "Inviti inviati",
          helper: "Stato degli inviti che hai inviato.",
          emptyLabel: "Nessun invito inviato.",
          icon: "fa-solid fa-paper-plane",
          invites: sent,
        },
        {
          key: "received",
          label: "Inviti ricevuti",
          helper: "Inviti condivisi con te dai colleghi.",
          emptyLabel: "Nessun invito ricevuto.",
          icon: "fa-solid fa-inbox",
          invites: received,
        },
      ].filter((group) => group.invites.length > 0);
    },
    invitiInviatiInAttesa() {
      return this.invitiCombinati.filter(
        (invito) => invito.tipo === "inviato" && invito.stato === "in attesa"
      );
    },
    canCancelAllSentInvites() {
      return this.invitiInviatiInAttesa.length > 1;
    },
    invitiInAttesaCount() {
      return this.invitiRicevuti.filter(
        (i) => i.stato === "in attesa" && i.tipo_piano === this.tipoPiano
      ).length;
    },
  },
  mounted() {
    if (this.isGuestMode) {
      return;
    }

    this.fetchUtentiStudio();
  },
  watch: {
    autoOpen: {
      immediate: true,
      handler(value) {
        if (value) {
          this.openModal();
        }
      },
    },
    highlightedInvitoId(value) {
      if (value) {
        this.openModal();
      }
    },
  },
  methods: {
    openModal() {
      if (this.isGuestMode) {
        return;
      }

      this.showModal = true;
      this.actionError = "";
    },
    closeModal() {
      this.showModal = false;
      this.actionError = "";
      this.showCancelAllConfirm = false;
    },
    emitError(message) {
      this.actionError = message;
      this.$emit("error", message);
    },
    normalizeInviteSharedFiles(invito) {
      if (
        Array.isArray(invito.shared_files) &&
        invito.shared_files.length > 0
      ) {
        return invito.shared_files;
      }

      return [
        {
          key: "main",
          label: invito.tipo_piano || this.tipoPiano,
        },
      ];
    },
    shortFileLabel(label) {
      if (!label) {
        return "Anteprima";
      }

      const compactLabels = {
        "Piano dei Conti": "Piano",
        "Piano Codici Tributo": "Piano",
        "Archivio Descrizioni Cod. Conto": "Archivio",
        "Archivio Codici Tributo 9001": "9001",
        "Archivio Coordinate Bancarie": "Coordinate",
      };

      if (label.startsWith("Piano dei Conti - ")) {
        return "Piano";
      }
      if (label.startsWith("Archivio Descrizioni - ")) {
        return "Archivio";
      }

      return compactLabels[label] || label;
    },
    buildUpdatedFilesMessage(invito) {
      const sharedFiles = this.normalizeInviteSharedFiles(invito);
      const labels = sharedFiles
        .map((file) => file.label)
        .filter(
          (label) => typeof label === "string" && label.trim().length > 0
        );

      if (!labels.length) {
        return `${this.tipoPiano} aggiornato con successo!`;
      }

      if (labels.length === 1) {
        return `${labels[0]} aggiornato con successo!`;
      }

      if (labels.length === 2) {
        return `${labels[0]} e ${labels[1]} aggiornati con successo!`;
      }

      const lastLabel = labels[labels.length - 1];
      const leadingLabels = labels.slice(0, -1);
      return `${leadingLabels.join(
        ", "
      )} e ${lastLabel} aggiornati con successo!`;
    },
    isResponding(invitoId) {
      return Boolean(this.loadingRisposte[invitoId]);
    },
    isHighlightedInvito(invito) {
      return (
        this.highlightedInvitoId !== null &&
        String(invito.id) === String(this.highlightedInvitoId)
      );
    },
    getUserSortKey(user) {
      const lastName = (user.last_name || "").trim();
      const firstName = (user.first_name || "").trim();
      const email = (user.email || "").trim();
      return `${lastName}|${firstName}|${email}`.toLowerCase();
    },
    formatUserDisplayName(user) {
      const firstName = (user.first_name || "").trim();
      const lastName = (user.last_name || "").trim();
      const fullName = [firstName, lastName].filter(Boolean).join(" ");
      return fullName || user.email;
    },
    avatarInitialsFromText(value) {
      const text = String(value || "?").trim();
      const localPart = text.includes("@") ? text.split("@")[0] : text;
      const words = localPart
        .replace(/[._-]+/g, " ")
        .split(/\s+/)
        .filter(Boolean);

      if (!words.length) return "?";
      if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
      return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
    },
    avatarStyleForText(value) {
      const text = String(value || "?");
      const shade = [...text].reduce(
        (total, character) => total + character.charCodeAt(0),
        0
      );
      const bluePalettes = [
        { background: "#e6f0ff", color: "#1d5eaf" },
        { background: "#dceafe", color: "#1e63bb" },
        { background: "#eaf2ff", color: "#255c9f" },
      ];
      return bluePalettes[shade % bluePalettes.length];
    },
    recipientInitials(user) {
      return this.avatarInitialsFromText(this.formatUserDisplayName(user));
    },
    recipientAvatarStyle(user) {
      return this.avatarStyleForText(
        `${this.formatUserDisplayName(user)}|${user.email || ""}`
      );
    },
    inviteStatusClass(status) {
      const normalizedStatus = String(status || "").toLowerCase();
      if (normalizedStatus.includes("accett")) return "invite-status--accepted";
      if (normalizedStatus.includes("rifiut")) return "invite-status--rejected";
      return "invite-status--pending";
    },
    shouldShowUserEmail(user) {
      const firstName = (user.first_name || "").trim();
      const lastName = (user.last_name || "").trim();
      return Boolean(firstName || lastName);
    },
    selezionaTuttiUtenti() {
      this.selectedUserEmails = this.sortedUtentiStudio.map(
        (user) => user.email
      );
    },
    deselezionaTuttiUtenti() {
      this.selectedUserEmails = [];
    },
    fetchUtentiStudio() {
      if (this.isGuestMode) {
        this.utentiStudio = [];
        return;
      }

      axios
        .get(`${API_BASE_URL}/piano_condiviso/colleghi`)
        .then((res) => {
          this.utentiStudio = Array.isArray(res.data.colleghi)
            ? res.data.colleghi
            : [];
        })
        .catch((err) => {
          console.error("Errore nel recupero utenti dello studio:", err);
          this.emitError("Impossibile caricare l'elenco dei colleghi.");
        });
    },
    formattaData(data) {
      if (!data) return "N/D";
      const d = new Date(data);
      return d.toLocaleDateString("it-IT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    inviaPiano() {
      if (!this.canSend) {
        return;
      }

      this.actionError = "";
      this.isSending = true;

      axios
        .post(`${API_BASE_URL}/piano_condiviso/invia`, {
          destinatari_emails: this.selectedUserEmails,
          tipo_piano: this.tipoPiano,
          file_keys: this.selectedFileKeysForSubmit,
        })
        .then((response) => {
          const createdCount = response.data.created_count || 0;
          this.selectedUserEmails = [];
          this.selectedFileKeys = [];
          this.$emit(
            "success",
            createdCount > 1
              ? `Invito inviato a ${createdCount} colleghi.`
              : "Invito inviato con successo!"
          );
          this.$emit("refresh-inviti");
        })
        .catch((error) => {
          console.error("Errore nell'invio del piano:", error);
          const message =
            error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : "Errore durante l'invio della condivisione.";
          this.emitError(message);
        })
        .finally(() => {
          this.isSending = false;
        });
    },
    async visualizzaExcel(invitoId, file) {
      this.actionError = "";

      try {
        const response = await axios.get(
          `${API_BASE_URL}/piano_condiviso/visualizza/${invitoId}`,
          {
            params: { file_key: file.key },
            responseType: "blob",
          }
        );

        const blob = response.data;
        const fileReader = new FileReader();
        fileReader.onload = (event) => {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          this.$emit("mostra-excel", rows);
        };
        fileReader.readAsArrayBuffer(blob);
      } catch (error) {
        console.error("Errore nel recupero del file Excel:", error);
        const message =
          error.response && error.response.data && error.response.data.error
            ? error.response.data.error
            : `Errore nel recupero del file "${file.label}".`;
        this.emitError(message);
      }
    },
    annullaInvito(invitoId) {
      this.showCancelAllConfirm = false;
      this.$set(this.loadingAnnullamenti, invitoId, true);
      this.actionError = "";

      axios
        .post(`${API_BASE_URL}/piano_condiviso/annulla`, {
          invito_id: invitoId,
        })
        .then(() => {
          this.$emit("refresh-inviti");
          this.$emit("success", "Invito annullato con successo.");
        })
        .catch((err) => {
          console.error("Errore nell'annullamento invito:", err);
          const message =
            err.response && err.response.data && err.response.data.error
              ? err.response.data.error
              : "Errore durante l'annullamento dell'invito.";
          this.emitError(message);
        })
        .finally(() => {
          setTimeout(() => {
            this.$set(this.loadingAnnullamenti, invitoId, false);
          }, 600);
        });
    },
    requestCancelAllSentInvites() {
      this.actionError = "";
      this.showCancelAllConfirm = true;
    },
    async annullaTuttiInvitiInviati() {
      const invitiDaAnnullare = this.invitiInviatiInAttesa;

      if (!invitiDaAnnullare.length || this.isCancellingAllInvites) {
        return;
      }

      this.actionError = "";
      this.isCancellingAllInvites = true;
      invitiDaAnnullare.forEach((invito) => {
        this.$set(this.loadingAnnullamenti, invito.id, true);
      });

      const results = await Promise.allSettled(
        invitiDaAnnullare.map((invito) =>
          axios.post(`${API_BASE_URL}/piano_condiviso/annulla`, {
            invito_id: invito.id,
          })
        )
      );

      const failedCount = results.filter(
        (result) => result.status === "rejected"
      ).length;
      const successCount = invitiDaAnnullare.length - failedCount;

      invitiDaAnnullare.forEach((invito) => {
        this.$set(this.loadingAnnullamenti, invito.id, false);
      });

      this.isCancellingAllInvites = false;
      this.showCancelAllConfirm = false;
      this.$emit("refresh-inviti");

      if (failedCount === 0) {
        this.$emit(
          "success",
          successCount === 1
            ? "Invito annullato con successo."
            : `${successCount} inviti annullati con successo.`
        );
        return;
      }

      const message =
        successCount > 0
          ? `${successCount} inviti annullati, ${failedCount} non annullati.`
          : "Non è stato possibile annullare gli inviti.";
      this.emitError(message);
    },
    rispondi(invitoId, risposta) {
      this.$set(this.loadingRisposte, invitoId, true);
      this.actionError = "";
      const invito = this.invitiCombinati.find((item) => item.id === invitoId);

      axios
        .post(`${API_BASE_URL}/piano_condiviso/rispondi`, {
          invito_id: invitoId,
          risposta,
        })
        .then(() => {
          const messaggio =
            risposta === "accettato"
              ? this.buildUpdatedFilesMessage(
                  invito || { tipo_piano: this.tipoPiano }
                )
              : `${this.tipoPiano} non aggiornato`;
          this.$emit("success", messaggio);

          if (this.onRefreshFiles) {
            const refreshResult = this.onRefreshFiles();
            if (refreshResult && typeof refreshResult.finally === "function") {
              refreshResult.finally(() => {
                this.$emit("refresh-inviti");
              });
              return;
            }
          }

          this.$emit("refresh-inviti");
        })
        .catch((error) => {
          console.error("Errore nella risposta all'invito:", error);
          const message =
            error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : "Errore durante la risposta all'invito.";
          this.emitError(message);
        })
        .finally(() => {
          this.$set(this.loadingRisposte, invitoId, false);
        });
    },
  },
};
</script>

<style scoped>
.btn-condividi {
  background-color: #ffffff;
  color: #333;
  font-size: 0.95rem;
  border: none;
  padding: 9px 18px;
  border-radius: 20px;
  font-weight: 500;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s ease;
}

.btn-condividi:hover {
  background-color: rgb(198, 233, 247);
  transform: translateY(-1px);
}

.btn-condividi:disabled {
  opacity: 0.5;
  background-color: #f0f0f0;
  cursor: not-allowed;
  transform: none;
}

.btn-condividi:disabled .fa-share-nodes {
  color: #a9afb4 !important;
}

.badge {
  background: red;
  color: white;
  font-size: 0.75rem;
  padding: 2px 6px;
  border-radius: 9999px;
  position: absolute;
  top: -5px;
  right: -5px;
  font-weight: bold;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content.condividi-modal {
  background: white;
  border-radius: 10px;
  width: 900px;
  max-width: min(92vw, 900px);
  height: calc(100vh - 42px);
  max-height: calc(100vh - 42px);
  padding: 16px 24px 18px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-content h3 {
  margin-bottom: 12px;
  font-weight: 700;
  color: #4e5963;
  font-size: 1.32rem;
}

.share-feedback {
  margin-bottom: 14px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 0.92rem;
}

.share-feedback.error {
  background: #fdecec;
  color: #a53030;
  border: 1px solid #f2c3c3;
}

.modal-body {
  display: flex;
  gap: 22px;
  flex-wrap: nowrap;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.modal-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}

.modal-section h4 {
  flex: 0 0 auto;
  margin-bottom: 12px;
  font-weight: 600;
  border-bottom: 2px solid #2d7bce;
  padding-bottom: 8px;
  color: #2d7bce;
  font-size: 1.1rem;
}

.share-compose-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

.bulk-cancel-toolbar {
  display: flex;
  justify-content: flex-end;
  margin: -6px 2px 8px;
}

.btn-annulla-tutti {
  padding: 3px 0;
  border: none;
  background: transparent;
  color: #7b8794;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.3;
  cursor: pointer;
}

.btn-annulla-tutti:hover:not(:disabled) {
  color: #4b5563;
  text-decoration: underline;
}

.btn-annulla-tutti:disabled {
  color: #aeb7c2;
  cursor: wait;
}

.bulk-cancel-confirm {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: -4px 0 10px;
  padding: 8px 10px;
  border: 1px solid #e1e6ec;
  border-radius: 6px;
  background: #fafcff;
  color: #5f6a75;
  font-size: 0.82rem;
}

.bulk-cancel-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.bulk-cancel-action {
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 2px 4px;
  cursor: pointer;
}

.bulk-cancel-action:hover:not(:disabled) {
  color: #374151;
  text-decoration: underline;
}

.bulk-cancel-action--confirm {
  color: #b33a3a;
}

.bulk-cancel-action--confirm:hover:not(:disabled) {
  color: #8f2c2c;
}

.bulk-cancel-action:disabled {
  color: #aeb7c2;
  cursor: wait;
}

.selection-card {
  border: 1px solid #e1e6ec;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 12px;
  background: #fafcff;
}

.selection-card--files {
  margin-bottom: 14px;
}

.selection-card--users {
  margin-top: 8px;
  margin-bottom: 0;
}

.section-helper {
  margin: 0 0 8px;
  color: #5f6a75;
  font-size: 0.84rem;
  line-height: 1.4;
}

.share-file-list {
  max-height: none;
  overflow-y: auto;
  padding: 3px 5px 5px;
}

.share-file-section + .share-file-section {
  margin-top: 10px;
}

.share-file-section-title {
  display: block;
  margin: 0 0 6px;
  color: #6b7785;
  font-size: 0.68rem;
  font-weight: 850;
  letter-spacing: 0.06em;
  text-align: center;
  text-transform: uppercase;
}

.share-main-list,
.share-client-list,
.share-client-actions {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.share-file-row,
.share-file-chip {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
  border: 1px solid #d8e4ee;
  border-radius: 8px;
  background: #ffffff;
  color: #203244;
  cursor: pointer;
}

.share-file-row {
  gap: 8px;
  padding: 7px 9px;
}

.share-file-row.selected,
.share-file-chip.selected {
  border-color: rgba(35, 100, 170, 0.45);
  background: #eef5fc;
  box-shadow: inset 3px 0 0 #2364aa;
}

.share-file-row input,
.share-file-chip input {
  flex: 0 0 auto;
  width: 15px;
  height: 15px;
  margin: 0;
  cursor: pointer;
}

.share-file-row > i,
.share-file-chip > i {
  flex: 0 0 auto;
  color: #3f5d74;
  font-size: 0.85rem;
}

.share-file-row-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  text-align: left;
}

.share-file-row-text strong {
  overflow: hidden;
  color: #102a3e;
  font-size: 0.84rem;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.share-file-row-text small {
  margin-top: 1px;
  color: #66788a;
  font-size: 0.7rem;
}

.share-client-group {
  padding: 8px;
  border: 1px solid #dde7e8;
  border-radius: 10px;
  background: #ffffff;
}

.share-client-heading {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  margin-bottom: 7px;
  color: #082840;
  font-size: 0.82rem;
  font-weight: 800;
  text-align: left;
}

.share-client-heading i {
  color: #f59e0b;
  font-size: 0.7rem;
}

.share-client-heading span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.share-client-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

.share-file-chip {
  gap: 6px;
  min-height: 2rem;
  padding: 0 7px;
  font-size: 0.78rem;
  font-weight: 750;
}

.share-file-chip.selected {
  border-color: rgba(217, 119, 6, 0.5);
  background: #fff7e8;
  box-shadow: inset 3px 0 0 #d97706;
}

.share-file-chip.selected > i {
  color: #9a5a05;
}

.share-file-chip span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.share-file-status {
  margin-left: auto;
  padding: 1px 5px;
  border-radius: 999px;
  background: #edf2f7;
  color: #52677c;
  font-size: 0.62rem;
  font-weight: 850;
  line-height: 1.25;
}

.share-file-status--empty {
  background: #eef2f5;
  color: #52677c;
}

.selection-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.toolbar-link {
  border: none;
  background: transparent;
  color: #2d7bce;
  font-size: 0.84rem;
  font-weight: 600;
  padding: 0;
  cursor: pointer;
}

.toolbar-link:disabled {
  color: #9db5d4;
  cursor: not-allowed;
}

.toolbar-count {
  margin-left: auto;
  color: #687687;
  font-size: 0.82rem;
}

.checkbox-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: none;
  overflow-y: auto;
  padding: 6px 6px 8px 6px;
}

.checkbox-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.88rem;
  color: #2f3942;
}

.checkbox-row input {
  width: 15px;
  height: 15px;
  margin-top: 3px;
  cursor: pointer;
}

.user-option-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  align-items: flex-start;
  text-align: left;
}

.user-option-name {
  display: block;
  width: 100%;
  font-weight: 500;
  font-size: 0.86rem;
  color: #3c4957;
  word-break: break-word;
}

.user-option-email {
  display: block;
  width: 100%;
  margin-top: 1px;
  color: #768292;
  font-size: 0.76rem;
  line-height: 1.3;
  text-align: left;
  word-break: break-word;
}

.checkbox-row input:disabled {
  cursor: default;
}

.selection-summary {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  color: #5a6977;
  font-size: 0.85rem;
}

.share-send-footer {
  flex: 0 0 auto;
  padding-top: 10px;
  background: #ffffff;
}

.empty-state {
  margin: 0;
  color: #78828d;
  font-style: italic;
}

.btn-invia {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.25s ease;
}

.btn-invia:disabled {
  background-color: #a0c5ff;
  cursor: not-allowed;
}

.lista-inviti {
  list-style: none;
  padding: 0;
  margin: 0;
  overflow-y: auto;
  max-height: 360px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

.invito-item {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 12px;
  border-bottom: 1px solid #eee;
  align-items: flex-start;
}

.invito-item:last-child {
  border-bottom: none;
}

.invito-item.highlighted {
  background: #fff7df;
  border-left: 4px solid #f0b429;
  box-shadow: inset 0 0 0 1px rgba(240, 180, 41, 0.25);
}

.info-invito {
  font-size: 0.9rem;
  color: #333;
  flex: 1;
  min-width: 0;
  text-align: left;
}

.invito-user {
  display: block;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.invito-type {
  display: block;
  margin-bottom: 4px;
}

.invito-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  margin: 2px 0 8px;
  color: #555;
  font-size: 0.82rem;
}

.shared-files {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 6px;
  margin: 8px 0 6px;
}

.file-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 999px;
  background: #eef5fd;
  color: #34618f;
  font-size: 0.77rem;
}

.invito-controls {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  min-width: 185px;
}

.preview-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.btn-preview {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  padding: 6px 9px;
  border-radius: 5px;
  border: 1px solid #cccccc;
  background: white;
  color: #737373;
  cursor: pointer;
  font-weight: 500;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s ease, border 0.2s ease;
}

.btn-preview:hover {
  background-color: #f3f3f3;
  border: 1px solid #aaaaaa;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
}

.actions {
  display: flex;
  justify-content: flex-end;
}

.actions button {
  padding: 6px 10px;
  border-radius: 5px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-accetta {
  background-color: #28a745;
  color: white;
}

.btn-accetta:hover {
  background-color: #218838;
}

.btn-rifiuta {
  background-color: #dc3545;
  color: white;
  margin-left: 6px;
}

.btn-rifiuta:hover {
  background-color: #c82333;
}

.btn-annulla {
  background-color: #e0e0e0;
  color: #333;
  border: 1px solid #ccc;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-annulla:hover {
  background-color: #d5d5d5;
}

.no-inviti {
  font-style: italic;
  color: #777;
  padding: 20px 0;
  text-align: center;
}

.modal-footer {
  margin-top: 14px;
  text-align: right;
}

.btn-chiudi {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.25s ease;
}

.btn-chiudi:hover {
  background-color: #5a6268;
}

.fa-share-nodes {
  color: #2ea7db;
  font-size: 1.1rem;
}

@media (max-width: 960px) {
  .modal-content.condividi-modal {
    width: 94vw;
    padding: 18px 18px 20px;
  }

  .modal-body {
    flex-direction: column;
    min-height: 0;
  }

  .toolbar-count {
    width: 100%;
    margin-left: 0;
  }

  .invito-item {
    flex-direction: column;
  }

  .invito-controls {
    align-items: flex-start;
    min-width: 0;
    width: 100%;
  }

  .preview-actions {
    justify-content: flex-start;
  }
}

/* Restyling compatto della finestra condivisa dalle due librerie. */
.modal-overlay {
  padding: 1rem;
  box-sizing: border-box;
  background: rgba(8, 31, 25, 0.6);
  backdrop-filter: blur(2px);
}

.modal-content.condividi-modal {
  width: min(80rem, calc(100vw - 2rem));
  max-width: 80rem;
  height: min(43rem, calc(100dvh - 2rem));
  min-height: 34rem;
  max-height: calc(100dvh - 2rem);
  padding: 0;
  border: 1px solid #d8e5df;
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(7, 31, 24, 0.28);
  text-align: left;
}

.share-modal-header {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex: 0 0 auto;
  min-height: 5rem;
  box-sizing: border-box;
  padding: 0.9rem 1.25rem;
  border-bottom: 1px solid #e3ebe7;
  background: linear-gradient(105deg, #ffffff 0%, #fbfefd 100%);
}

.share-modal-icon,
.section-heading-icon,
.selection-card-icon,
.invite-group-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.share-modal-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 14px;
  background: #dcf7ea;
  color: #07865f;
  font-size: 1.25rem;
}

.share-modal-icon .fa-share-nodes {
  color: inherit;
  font-size: inherit;
}

.share-modal-title {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.share-modal-title strong {
  color: #082840;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.2;
}

.share-modal-title small {
  margin-top: 0.15rem;
  color: #607284;
  font-size: 0.84rem;
}

.share-modal-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  margin-left: auto;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: #637586;
  cursor: pointer;
  font-size: 1.05rem;
}

.share-modal-close:hover {
  background: #eef4f1;
  color: #174f3e;
}

.share-feedback {
  flex: 0 0 auto;
  margin: 0.7rem 1.2rem 0;
  padding: 0.55rem 0.75rem;
}

.modal-body {
  display: grid;
  grid-template-columns: minmax(0, 0.92fr) minmax(0, 1.08fr);
  gap: 0.9rem;
  padding: 0.9rem 1.2rem 1rem;
}

.modal-section {
  overflow: hidden;
  border: 1px solid #dce6e1;
  border-radius: 14px;
  background: #ffffff;
}

.modal-section-heading {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  flex: 0 0 auto;
  min-height: 4.05rem;
  box-sizing: border-box;
  padding: 0.7rem 0.85rem;
  border-bottom: 1px solid #e3ebe7;
  background: #fbfdfc;
}

.modal-section-heading > span:nth-child(2),
.invite-group-title,
.selection-card-title {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.modal-section-heading strong {
  color: #102d43;
  font-size: 1rem;
  font-weight: 800;
}

.modal-section-heading small {
  margin-top: 0.05rem;
  color: #6a7a89;
  font-size: 0.73rem;
}

.section-heading-icon {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 10px;
  font-size: 0.9rem;
}

.section-heading-icon--share {
  background: #e0f6eb;
  color: #087d5d;
}

.section-heading-icon--invites {
  background: #e5f0ff;
  color: #2267bd;
}

.invite-total,
.invite-group-count,
.selection-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 999px;
  font-weight: 750;
}

.invite-total {
  min-width: 1.65rem;
  height: 1.65rem;
  margin-left: auto;
  background: #e4f0ff;
  color: #246bbd;
  font-size: 0.72rem;
}

.share-compose-scroll {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  overflow: hidden;
  padding: 0.7rem;
}

.selection-card {
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin: 0;
  padding: 0.65rem;
  border-color: #dfe8e4;
  border-radius: 12px;
  background: #fbfdfc;
}

.selection-card--files {
  flex: 0 1 47%;
  margin: 0;
}

.selection-card--users {
  flex: 1 1 53%;
  margin: 0;
}

.selection-card-heading {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  flex: 0 0 auto;
  margin-bottom: 0.55rem;
}

.selection-card-icon {
  width: 2rem;
  height: 2rem;
  border-radius: 9px;
  font-size: 0.82rem;
}

.selection-card-icon--files {
  background: #e5f0ff;
  color: #1d66bd;
}

.selection-card-icon--users {
  background: #ddf6e9;
  color: #087c5a;
}

.selection-card-title strong {
  color: #112c41;
  font-size: 0.88rem;
  font-weight: 800;
}

.selection-card-title small {
  color: #6b7a88;
  font-size: 0.68rem;
}

.selection-count {
  margin-left: auto;
  padding: 0.22rem 0.5rem;
  background: #edf3f8;
  color: #51687b;
  font-size: 0.65rem;
}

.share-file-list {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  padding: 0 0.15rem 0.15rem;
}

.share-file-section + .share-file-section {
  margin-top: 0.5rem;
}

.share-file-section-title {
  margin-bottom: 0.3rem;
  text-align: left;
  font-size: 0.62rem;
}

.share-main-list,
.share-client-list,
.share-client-actions {
  gap: 0.35rem;
}

.share-file-row,
.share-file-chip {
  min-height: 2.35rem;
  border-color: #dce5e9;
  border-radius: 9px;
}

.share-file-row {
  gap: 0.5rem;
  padding: 0.4rem 0.55rem;
}

.share-file-row.selected,
.share-file-chip.selected {
  border-color: #77c8a9;
  background: #edf9f4;
  box-shadow: none;
}

.share-file-row input,
.share-file-chip input,
.checkbox-row input {
  appearance: none;
  display: inline-grid;
  place-content: center;
  flex: 0 0 auto;
  width: 1.15rem;
  height: 1.15rem;
  margin: 0;
  border: 1.5px solid #9aa9b5;
  border-radius: 5px;
  background: #ffffff;
  cursor: pointer;
}

.share-file-row input::after,
.share-file-chip input::after,
.checkbox-row input::after {
  content: "";
  width: 0.55rem;
  height: 0.3rem;
  margin-top: -0.08rem;
  border-left: 2px solid #ffffff;
  border-bottom: 2px solid #ffffff;
  opacity: 0;
  transform: rotate(-45deg);
}

.share-file-row input:checked,
.share-file-chip input:checked,
.checkbox-row input:checked {
  border-color: #0b9668;
  background: #0b9668;
}

.share-file-row input:checked::after,
.share-file-chip input:checked::after,
.checkbox-row input:checked::after {
  opacity: 1;
}

.share-file-row-text strong {
  font-size: 0.78rem;
}

.share-file-row-text small {
  font-size: 0.65rem;
}

.share-client-group {
  padding: 0.45rem;
  border-radius: 9px;
}

.share-client-heading {
  margin-bottom: 0.4rem;
  font-size: 0.75rem;
}

.share-file-chip {
  min-height: 1.9rem;
  padding: 0 0.45rem;
  font-size: 0.7rem;
}

.selection-toolbar {
  flex: 0 0 auto;
  gap: 0.75rem;
  margin: 0 0 0.35rem;
  padding: 0 0.15rem;
}

.toolbar-link {
  color: #147b5b;
  font-size: 0.72rem;
}

.checkbox-list {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  gap: 0.35rem;
  padding: 0 0.15rem 0.1rem;
}

.checkbox-row {
  align-items: center;
  gap: 0.5rem;
  min-height: 2.7rem;
  box-sizing: border-box;
  padding: 0.35rem 0.5rem;
  border: 1px solid #e0e7eb;
  border-radius: 9px;
  background: #ffffff;
}

.checkbox-row:has(input:checked) {
  border-color: #80c9ae;
  background: #eef9f4;
}

.recipient-avatar,
.invite-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border-radius: 50%;
  font-weight: 850;
  letter-spacing: -0.02em;
}

.recipient-avatar {
  width: 2rem;
  height: 2rem;
  font-size: 0.72rem;
}

.user-option-name {
  font-size: 0.76rem;
  font-weight: 750;
  color: #22384a;
}

.user-option-email {
  font-size: 0.67rem;
}

.invite-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0.7rem;
}

.invite-group {
  overflow: hidden;
  border: 1px solid #dce6e1;
  border-radius: 12px;
  background: #fcfefd;
}

.invite-group + .invite-group {
  margin-top: 0.65rem;
}

.invite-group--sent {
  border-color: #dbe6f3;
}

.invite-group--received {
  border-color: #d7e9e1;
}

.invite-group-heading {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  min-height: 3.35rem;
  box-sizing: border-box;
  padding: 0.55rem 0.65rem;
  border-bottom: 1px solid #e5ebe8;
  background: #f7fafc;
}

.invite-group--received .invite-group-heading {
  background: #f3fbf7;
}

.invite-group-icon {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: #e5f0ff;
  color: #2169c3;
  font-size: 0.78rem;
}

.invite-group--received .invite-group-icon {
  background: #dcf6e9;
  color: #07845d;
}

.invite-group-title strong {
  color: #122d43;
  font-size: 0.82rem;
  font-weight: 800;
}

.invite-group-title small {
  color: #6d7c89;
  font-size: 0.65rem;
}

.invite-group-count {
  min-width: 1.4rem;
  height: 1.4rem;
  background: #e4effd;
  color: #2469ba;
  font-size: 0.65rem;
}

.invite-group--received .invite-group-count {
  background: #ddf3e8;
  color: #087b5a;
}

.btn-annulla-tutti {
  margin-left: auto;
  padding: 0.3rem 0.55rem;
  border: 1px solid #d8e0e6;
  border-radius: 7px;
  background: #ffffff;
  font-size: 0.68rem;
  text-decoration: none;
}

.btn-annulla-tutti:hover:not(:disabled) {
  border-color: #bec9d2;
  background: #f5f7f8;
  text-decoration: none;
}

.bulk-cancel-confirm {
  flex: 0 0 auto;
  margin: 0.65rem 0.7rem 0;
  padding: 0.45rem 0.6rem;
  font-size: 0.72rem;
}

.lista-inviti {
  max-height: none;
  border: 0;
  border-radius: 0;
  overflow: visible;
}

.invito-item {
  display: grid;
  grid-template-columns: 2.25rem minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.65rem;
  padding: 0.65rem;
  border-bottom-color: #e7ece9;
  background: #ffffff;
}

.invite-avatar {
  width: 2.25rem;
  height: 2.25rem;
  font-size: 0.72rem;
}

.invito-user {
  margin: 0;
  color: #122b40;
  font-size: 0.77rem;
  font-weight: 800;
}

.invito-meta {
  align-items: center;
  gap: 0.3rem 0.55rem;
  margin: 0.1rem 0 0.35rem;
  color: #6b7a88;
  font-size: 0.67rem;
}

.invite-status {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.4rem;
  border-radius: 999px;
  font-size: 0.61rem;
  font-style: normal;
  font-weight: 800;
  text-transform: capitalize;
}

.invite-status--pending {
  background: #fff3d8;
  color: #9a6100;
}

.invite-status--accepted {
  background: #def5e9;
  color: #087759;
}

.invite-status--rejected {
  background: #fde7eb;
  color: #b52943;
}

.shared-files {
  display: none;
}

.invito-controls {
  min-width: 0;
  gap: 0.45rem;
}

.preview-actions {
  justify-content: flex-start;
  gap: 0.3rem;
}

.btn-preview {
  max-width: 12rem;
  gap: 0.3rem;
  padding: 0.3rem 0.45rem;
  border-color: #dce5e9;
  border-radius: 7px;
  background: #f8fbfa;
  color: #376075;
  box-shadow: none;
  font-size: 0.65rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.actions {
  gap: 0.35rem;
}

.actions button,
.btn-annulla {
  padding: 0.42rem 0.65rem;
  border-radius: 7px;
  font-size: 0.68rem;
  white-space: nowrap;
}

.btn-accetta {
  background: #0b9467;
}

.btn-rifiuta {
  margin-left: 0;
  background: #fde6eb;
  color: #bb2945;
}

.btn-rifiuta:hover {
  background: #f9d6dd;
}

.btn-annulla {
  border-color: #d8e0e5;
  background: #f1f4f6;
  color: #4d5f6e;
}

.invite-empty,
.no-inviti {
  margin: 0;
  padding: 0.8rem;
  color: #7a8791;
  font-size: 0.74rem;
  font-style: italic;
  text-align: center;
}

.no-inviti {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  min-height: 0;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex: 0 0 auto;
  min-height: 4.6rem;
  box-sizing: border-box;
  margin: 0;
  padding: 0.8rem 1.2rem;
  border-top: 1px solid #e2eae6;
  background: #fbfdfc;
}

.selection-summary {
  display: flex;
  align-items: center;
  gap: 1.1rem;
  margin: 0;
  color: #627482;
  font-size: 0.75rem;
}

.selection-summary span {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.selection-summary i {
  color: #15805f;
}

.selection-summary strong {
  color: #17374a;
}

.modal-footer-actions {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.btn-invia,
.btn-chiudi {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-width: 7.5rem;
  min-height: 2.55rem;
  box-sizing: border-box;
  padding: 0.55rem 1rem;
  border-radius: 9px;
  font-size: 0.78rem;
  font-weight: 750;
}

.btn-invia {
  background: #0b8b62;
}

.btn-invia:hover:not(:disabled) {
  background: #087552;
}

.btn-invia:disabled {
  background: #b8d9cd;
}

.btn-chiudi {
  border: 1px solid #dbe3e7;
  background: #eef2f4;
  color: #405466;
}

.btn-chiudi:hover {
  background: #e3e9ec;
}

@media (max-width: 960px) {
  .modal-content.condividi-modal {
    width: calc(100vw - 1rem);
    height: calc(100dvh - 1rem);
    min-height: 0;
    max-height: calc(100dvh - 1rem);
    padding: 0;
  }

  .modal-body {
    display: flex;
    overflow-y: auto;
  }

  .modal-section {
    flex: 0 0 auto;
    min-height: 28rem;
  }

  .share-compose-scroll,
  .invite-scroll {
    overflow: visible;
  }

  .modal-footer {
    align-items: stretch;
    flex-direction: column;
  }

  .modal-footer-actions,
  .btn-invia,
  .btn-chiudi {
    width: 100%;
  }
}

@media (max-height: 640px) and (min-width: 961px) {
  .modal-content.condividi-modal {
    height: calc(100dvh - 1rem);
    min-height: 0;
    max-height: calc(100dvh - 1rem);
  }

  .share-modal-header {
    min-height: 4.4rem;
  }

  .modal-footer {
    min-height: 4rem;
  }
}

/* Correzioni di scala, tipografia e colore. */
.condividi-modal,
.condividi-modal button,
.condividi-modal input,
.condividi-modal select,
.condividi-modal textarea {
  font-family: inherit;
}

.modal-content.condividi-modal {
  width: min(76rem, calc(100vw - 3rem));
  max-width: 76rem;
}

.share-modal-icon,
.section-heading-icon,
.selection-card-icon,
.invite-group-icon {
  background: #e5f0ff;
  color: #2368b7;
}

.section-heading-icon--share,
.section-heading-icon--invites,
.selection-card-icon--files,
.selection-card-icon--users,
.invite-group--received .invite-group-icon {
  background: #e5f0ff;
  color: #2368b7;
}

.selection-summary i {
  color: #2368b7;
}

.share-file-row input,
.share-file-chip input,
.checkbox-row input {
  width: 16px;
  height: 16px;
  border-width: 1px;
  border-radius: 4px;
}

.share-file-row input::after,
.share-file-chip input::after,
.checkbox-row input::after {
  width: 6px;
  height: 3px;
  margin-top: -1px;
  border-left-width: 1.5px;
  border-bottom-width: 1.5px;
}

.share-file-type-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: #e5f0ff;
  color: #2368b7;
  font-size: 0.82rem;
}

.share-file-chip .share-file-type-icon {
  width: 1.65rem;
  height: 1.65rem;
  font-size: 0.7rem;
}

.selection-summary {
  gap: 1.35rem;
  font-size: 0.96rem;
  font-weight: 500;
}

.selection-summary span {
  gap: 0.45rem;
}

.selection-summary strong {
  font-size: 1.06rem;
  font-weight: 800;
}

.selection-summary i {
  font-size: 0.92rem;
}

@media (max-width: 1750px) and (min-width: 961px) {
  .modal-content.condividi-modal {
    width: 70vw;
    max-width: 70vw;
  }
}

@media (max-width: 1180px) and (min-width: 961px) {
  .modal-content.condividi-modal {
    width: 88vw;
    max-width: 88vw;
  }
}

@media (max-width: 960px) {
  .modal-content.condividi-modal {
    width: calc(100vw - 1rem);
    max-width: calc(100vw - 1rem);
  }
}

/* Scala tipografica leggibile anche su schermi da 15 pollici. */
.share-modal-title strong {
  font-size: 1.48rem;
}

.share-modal-title small {
  font-size: 0.9rem;
  line-height: 1.4;
}

.modal-section-heading strong {
  font-size: 1.08rem;
}

.modal-section-heading small {
  margin-top: 0.12rem;
  font-size: 0.82rem;
  line-height: 1.35;
}

.selection-card-title strong {
  font-size: 0.98rem;
}

.selection-card-title small {
  margin-top: 0.08rem;
  font-size: 0.77rem;
  line-height: 1.3;
}

.selection-count,
.invite-total,
.invite-group-count {
  font-size: 0.72rem;
}

.share-file-section-title {
  font-size: 0.69rem;
}

.share-file-row-text strong {
  font-size: 0.87rem;
  line-height: 1.25;
}

.share-file-row-text small {
  font-size: 0.73rem;
  line-height: 1.3;
}

.share-client-heading {
  font-size: 0.84rem;
}

.share-file-chip {
  font-size: 0.78rem;
}

.share-file-status {
  font-size: 0.69rem;
}

.toolbar-link {
  font-size: 0.79rem;
}

.user-option-name {
  font-size: 0.85rem;
  line-height: 1.25;
}

.user-option-email {
  margin-top: 0.12rem;
  font-size: 0.75rem;
  line-height: 1.3;
}

.invite-group-title strong {
  font-size: 0.98rem;
}

.invite-group-title small {
  margin-top: 0.1rem;
  font-size: 0.78rem;
  line-height: 1.35;
}

.invito-user {
  font-size: 0.86rem;
  line-height: 1.3;
}

.invito-meta {
  font-size: 0.75rem;
  line-height: 1.3;
}

.invite-status {
  font-size: 0.69rem;
}

.btn-preview {
  font-size: 0.73rem;
}

.actions button,
.btn-annulla,
.btn-annulla-tutti,
.bulk-cancel-action {
  font-size: 0.76rem;
}

.bulk-cancel-confirm,
.invite-empty,
.no-inviti,
.empty-state {
  font-size: 0.8rem;
  line-height: 1.4;
}

.btn-invia,
.btn-chiudi {
  font-size: 0.86rem;
}
</style>
